module.exports = {"Login":"Iniciar sesión","Registration":"Regístrese","Invest Ideas":"Ideas de inversión","Portfolio":"Mi portafolio","How It Works":"Cómo funciona","About UT Platform":"Sobre la plataforma UT","IPO":"OPI","Pre-IPO":"Pre-OPI","OTC":"OTC","Stocks and ETF":"Acciones y ETF","Deposit":"Reponer","Withdraw":"Retirar","My portfolio":"Mi portafolio","Free":"Libre","Invested":"Invertido","Current Profit":"Beneficio actual","All accounts":"Todas las cuentas"}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/header-microfrontend/locales/es/header.json
// module id = 1381
// module chunks = 118